import React from 'react'
import Header from '../Header'
import Sidebar from '../Sidebar'
import RecommendedVideos from '../RecommendedVideos'
import './Home.css'

function Home() {
   return (
     <div className="app">
       <Header />
      <div className="app__page">
        <Sidebar />
        <RecommendedVideos />
      </div>
     </div>
   )

 
}

export default Home
